module.exports = {
      id: "ic-volatility-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-volatility-normal-usage",
      toString: function () {
        return this.url;
      }
    }